AuthRoute = require 'mixins/authenticated-route'

App.SettingsBillingPayRoute = Em.Route.extend AuthRoute,
  model: (params) ->
    @store.createRecord 'payment',
      sum           : params.sum
      organization  : @controllerFor('settings.billing').get('organization')
